import { JurisdictionCodesType } from 'src/components/Common/Jurisdiction/types';
import { CarolinasJurisdictionSelectCardsInterface } from '../../../types';

const stateCodesToJurisdictions: { [key: string]: JurisdictionCodesType } = {
  IN: 'IN01',
  OH: 'OH01',
  KY: 'KY01',
  NC01: 'NC01',
  NC02: 'NC02',
  SC01: 'SC01',
  SC02: 'SC02',
};

export const checkJurisdiction = ({
  stateCode,
  setRegionSelectModalIsOpen,
  setJurisdiction,
}: CarolinasJurisdictionSelectCardsInterface) => {
  if (stateCode === 'NC' || stateCode === 'SC') {
    // if the user selected NC or SC in step 3 open the CarolinasJurisdictionModal so the user can select 'Duke Energy Carolinas' or 'Duke Energy Progress' region
    setRegionSelectModalIsOpen(true);
  } else {
    setJurisdiction(stateCodesToJurisdictions[stateCode]);
  }
};
